import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Space, Card, Row, Col, Flex } from 'antd';
import useLogin from '../../Hooks/Auth';
import { useNavigate } from "react-router-dom";
import pokeFondo from "../../Assets/pokeball.png";
import { LoginOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';

export const Auth = () => {
  const [form] = Form.useForm();
  let navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const login = useLogin(setIsLoading);

  useEffect(() => {
    localStorage.getItem("token") && navigate("/pokedex")
  }, [])


  const onFinish = async (values) => {
    setIsLoading(true)
    await login.mutateAsync({ usua_correo: values.email, usua_password: values.password })
    const isAdmin = localStorage.getItem("isAdmin");
    if(isAdmin == true || isAdmin == "true") {
      window.history.pushState({}, '','/administrarUsuarios');
    } else {
      window.history.pushState({}, '', '/pokedex');
    }
    
    window.location.reload();
    setIsLoading(false)
  };
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });
  return (

    <Flex
      justify='center'
      align='center'
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${pokeFondo})`,
        backgroundPosition: "center",
        backgroundRepeat: "center",
        filter: "invert(100%) opacity(40%)",
        zIndex: 0,
      }}
    >
      <Card
        style={{
          maxWidth: "60%",
          minWidth: isDesktopOrLaptop ? "40%" : "80%"
        }}

        title="Iniciar Sesión"
      >
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          disabled={isLoading}
        >
          <Form.Item
            name="email"
            label="Correo"
            rules={[
              {
                required: true,
                message: "Debe ingresar un correo",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label="Contraseña"
            style={{ backgroundColor: "white" }}
            rules={[
              {
                required: true,
                message: "Debe ingresar una contraseña",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button
                htmlType="submit"
                icon={<LoginOutlined />}
                loading={isLoading}
              >
                Entrar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </Flex>
  );
};